/**
 * The inbox reads: its rows and totals, and the navigation's one-bit „anything unread". A single
 * conversation is `useConversation`'s.
 */

import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';

import { useSessionUser } from '~/entities/session';

import { conversationsQueryOptions } from '../api/chatQueries';
import { toConversationRows, unreadTotals, type ConversationRow } from '../model/conversationRows';


export function useConversations() {
  const me = useSessionUser();
  const query = useQuery(conversationsQueryOptions());
  const rows = useMemo(() => toConversationRows(query.data, me?.id ?? null), [query.data, me?.id]);
  return {
    rows,
    totals: unreadTotals(rows),
    pending: query.isPending,
    failed: query.isError && query.data === undefined,
    refetch: () => {
      void query.refetch();
    },
  };
}

/** The navigation's dot: anything unread anywhere. Shares the inbox's cache entry. */
export function useHasUnreadChat(): boolean {
  const query = useQuery({ ...conversationsQueryOptions(), select: (rows) => rows.some((r) => (r.unreadCount ?? 0) > 0) });
  return query.data === true;
}

export type { ConversationRow };
